<!--
 * @FileDescription: 横向排列4级区域(省市区县镇)选择框
 * 传入参数 title 选择框标题
 * 传出参数 outAreas 区域ID对象{provId,cityId,distId,townId}
 * @Author: XuYao
 * @Date: 2020-04-27 23:10:02
 * @LastEditors: XuYao
 * @LastEditTime: 2020-04-27 23:10:02
-->
<template>
<div>
    <el-upload
               :action="_p_env.VUE_APP_BASE_API_PRE + '/pub/file/fileUpload'"
               :file-list="imgArr"
               :limit="1"
               accept=".png,.jpg"
               :on-success="imgSuccess"
               :on-remove="imgRemove"
               :on-preview="imgPreview"
               :before-upload="beforeUpload"
               :on-error="imgErr"
               list-type="picture-card"
               alt="图片丢失>~<"
               :class="{hide:upHide}">
        <i class="el-icon-plus"></i>
    </el-upload>

<!---->
    <el-dialog :visible.sync="showImgDlg" title="【点击图片可放大缩小】"
               :append-to-body="true"
    >
        <el-image placeholder="图片预览" fill
                  :preview-src-list="[dlgImgUrl]"
                  :src="dlgImgUrl">
        </el-image>

        <!--
        <div class="alignCenter"><img width="80%" :src="dlgImgUrl" alt="图片丢失"></div>
        -->

    </el-dialog>
</div>
</template>

<script>

    import {compressionImg} from "../../utils/datatool";

    export default {
        name: "ImgUpload",
        data() {
            return {
                imgArr:[],
                imgUrl: null,
                dlgImgUrl:'',
                upHide: false,
                showImgDlg: false,
                outImgUrl: null
            }
        },
        props:["inImgUrl"],
        mounted() {
            this.imgUrl = this.inImgUrl;
//            console.log('this.imgUrl:'+this.imgUrl);
            this.imgArr = [];
            if(this.imgUrl) {
//                console.log('----1');
                this.imgArr.push({url:this.imgUrl});
                this.upHide = true;
            }
            else {
//                console.log('----2');
                this.upHide = false;
            }
        },
        methods: {
            emitToParent() {
                this.outImgUrl = this.imgUrl;
                console.log("onImgUpSuc1");
                this.$emit("onImgUpSuc", this.outImgUrl)
                console.log("onImgUpSuc2");
                this.$emit('update:outImgUrl', this.outImgUrl);
            },
            imgPreview(file) {
                this.dlgImgUrl = file.url;
                this.showImgDlg = true;
            },
            imgRemove(file, fileList) {
                if(file.status==="success") {
                    this.upHide = false;
                    this.imgUrl = null;
                }
                this.emitToParent();
            },
            imgSuccess(response, file, fileList) {
                if (file.status==="success") {
                    this.imgUrl = response.obj.url;
                    this.upHide = true;
                }
                this.emitToParent();
            },
            imgErr(imgKey, err, file, fileList) {
                this.$message.error("图片上传失败!");
                this.imgArr = [];
                this.upHide = false;

                /**
                if (fileList.length >= 1)
                {
                    this.upHide = true;
                }
                */
            },
            beforeUpload(file) {


                let extName = file.name.substring(file.name.lastIndexOf('.')+1);
                extName = extName.toUpperCase();
                const extName1 = extName === 'PNG';
                const extName2 = extName === 'JPG';
                const lmtSize = file.size / 1024 / 1024 < 8;
                if(!extName1 && !extName2) {
                    this.$message({
                        message: '图片只允许jpg或png格式!',
                        type: 'warning'
                    });
                    return false;
                }
                if(!lmtSize) {
                    this.$message({
                        message: '图片大小不能超过 8MB!',
                        type: 'warning'
                    });
                    return false;
                }


                return new Promise((resolve, reject) => {
                    console.log("源文件大小:" + (file.size / 1024 / 1024 ) + "M");
                    const isLt1M = file.size / 1024 / 1024 < 1;
                    if (isLt1M) {
                        console.log("文件无需压缩！" );
                        resolve(file);
                    } else {
                        console.log("文件需要压缩！");
                        compressionImg(file , (newFile) =>  {
                            console.log("压缩后文件大小:" + (newFile.size / 1024 / 1024 ) + "M");
                            resolve(newFile);
                        });
                    }
                    this.upHide = true;
                    //return true;
                });
            }
        }
    }
</script>

<style scoped>

</style>
